import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=4d03c05e&"
import script from "./reg.vue?vue&type=script&lang=js&"
export * from "./reg.vue?vue&type=script&lang=js&"
import style0 from "./reg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports